//Healthy Ecosystems to Sustain Life: What We All Need for Survival

import { v4 as uuidv4 } from "uuid";

export const HE_OPTIONS = [
  {
    uid: uuidv4(),
    type: "environmental",
    value: "Healthy Water",
    imageSrc:
      "https://static.wixstatic.com/media/11062b_6c828b2f26204541b03871ad2d19e4eb~mv2.jpeg/v1/fill/w_2850,h_970,al_c,q_90,usm_0.66_1.00_0.01,enc_auto/11062b_6c828b2f26204541b03871ad2d19e4eb~mv2.jpeg",
    description:
      "Healthy water is a basic need for humans and all living things. According to the UN, about 5.5 billion people are going to face water shortages by 2050.",
    link: "https://www.youb.com/copy-of-healthy-ecosystems-to-sustain-1",
  },
  {
    uid: uuidv4(),
    type: "environmental",
    value: "Healthy Oceans",
    imageSrc:
      "https://static.wixstatic.com/media/c156cdb9851d4ed28e3ac9cdde60dabe.jpg/v1/fill/w_2850,h_970,al_c,q_90,usm_0.66_1.00_0.01,enc_auto/c156cdb9851d4ed28e3ac9cdde60dabe.jpg",
    description:
      "Oceans are essential to the planet's life support system, regulating the air we breathe, the climate we live in, the food we eat, and the absorption of carbon dioxide.",
    link: "https://www.youb.com/copy-of-healthy-ecosystems-to-sustain-1",
  },
  {
    uid: uuidv4(),
    type: "environmental",
    value: "Healthy Air",
    imageSrc:
      "https://static.wixstatic.com/media/dfe0d93f345840ed8aaabf5043bdf9db.jpg/v1/fill/w_2850,h_970,al_c,q_90,usm_0.66_1.00_0.01,enc_auto/dfe0d93f345840ed8aaabf5043bdf9db.jpg",
    description:
      "More than 90% of people across the world are chronically exposed to polluted air. This leads to almost 9 million premature deaths each year.",
    link: "https://www.youb.com/copy-of-healthy-ecosystems-to-sustain-1",
  },
  {
    uid: uuidv4(),
    type: "environmental",
    value: "Healthy Land",
    imageSrc:
      "https://static.wixstatic.com/media/11062b_6b1bf6b948b541179ca9f1645f03e753~mv2.jpg/v1/fill/w_2850,h_970,al_c,q_90,usm_0.66_1.00_0.01,enc_auto/11062b_6b1bf6b948b541179ca9f1645f03e753~mv2.jpg",
    description:
      "Healthy land is vital for all species survival and is integral in supporting biodiversity, food systems, and economic livelihoods around the world.",
    link: "https://www.youb.com/copy-of-healthy-ecosystems-to-sustain-1",
  },
  {
    uid: uuidv4(),
    type: "environmental",
    value: "Healthy Energy",
    imageSrc:
      "https://static.wixstatic.com/media/82c08d3efb804aa5a2af21ab98acde29.jpg/v1/fill/w_2850,h_970,al_c,q_90,usm_0.66_1.00_0.01,enc_auto/82c08d3efb804aa5a2af21ab98acde29.jpg",
    description:
      "Clean, renewable energy preserves the world’s natural resources and reduces air pollution, CO2 emissions, the risk of global warming, and environmental disasters such as fuel spills or problems associated with natural gas leaks.",
    link: "https://www.youb.com/copy-of-healthy-ecosystems-to-sustain-1",
  },
  {
    uid: uuidv4(),
    type: "environmental",
    value: "Healthy Habitats",
    imageSrc:
      "https://static.wixstatic.com/media/11062b_10581714a5b049d7a2ed999bee3b87c8~mv2.jpg/v1/fill/w_2850,h_970,al_c,q_90,usm_0.66_1.00_0.01,enc_auto/11062b_10581714a5b049d7a2ed999bee3b87c8~mv2.jpg",
    description:
      "Healthy habitats provide abundant resources to the variety of biodiversity that depend on them from shelter, food, and water.",
  },
  {
    uid: uuidv4(),
    type: "environmental",
    value: "Healthy Medicine",
    imageSrc:
      "https://static.wixstatic.com/media/11062b_4a433a28ee694a09ad4393be1f0f5c87~mv2.jpg/v1/fill/w_2850,h_970,al_c,q_90,usm_0.66_1.00_0.01,enc_auto/11062b_4a433a28ee694a09ad4393be1f0f5c87~mv2.jpg",
    description:
      "Healthy medicine is derived from nature. Because it is in harmony with nature, healthy medicine is biodegradable and is far less likely to harm other species.",
    link: "https://www.youb.com/copy-of-healthy-ecosystems-to-sustain-1",
  },
  {
    uid: uuidv4(),
    type: "environmental",
    value: "Healthy Food",
    imageSrc:
      "https://static.wixstatic.com/media/8ea70678ba8d4725b3ae79d832a5e7cd.jpg/v1/fill/w_2880,h_970,al_c,q_90,usm_0.66_1.00_0.01,enc_auto/8ea70678ba8d4725b3ae79d832a5e7cd.jpg",
    description:
      "Food is only as healthy as its source. Whether from a tree, the ground itself, the mountains, the ocean, or elsewhere, it is important to understand where your food comes from and how it was maintained, grown, and harvested.",
    link: "https://www.youb.com/copy-of-healthy-ecosystems-to-sustain-1",
  },

];

//Healthy Relationships with Nature: What We All Need for Survival
export const HR_NATURE_OPTIONS = [
  {
    uid: uuidv4(),
    type: "environmental",
    value: "Connection to Nature",
    imageSrc:
      "https://static.wixstatic.com/media/11062b_fba0080fa6c145998894df190c6afae7~mv2.jpg/v1/fill/w_2850,h_1072,al_c,q_90,usm_0.66_1.00_0.01,enc_auto/11062b_fba0080fa6c145998894df190c6afae7~mv2.jpg",
    description:
      "Our health benefits from greater contact with the environment. Connecting with animals, plants, fungi and algae, and all wildlife can expand our empathy for all living things and teach us that everything is interconnected.",
    link: "https://www.youb.com/basic-01",
  },
  {
    uid: uuidv4(),
    type: "environmental",
    value: "Environmental Science",
    imageSrc:
      "https://static.wixstatic.com/media/11062b_2c98db9f620e4fdd8ff773db9f624065~mv2.jpeg/v1/fill/w_2850,h_974,al_c,q_90,usm_0.66_1.00_0.01,enc_auto/11062b_2c98db9f620e4fdd8ff773db9f624065~mv2.jpeg",
    description:
      "Environmental science provides vital information on how we can utilize and protect our ecosystems and environmental resources. Scientific innovation can protect human health and biodiversity to support future generations.",
    link: "https://www.youb.com/basic-01",
  },
];

//Healthy Human Systems: Innovations and Actions for People and Planet
export const HHS_OPTIONS = [
  {
    uid: uuidv4(),
    type: "environmental",
    value: "Healthy Human Systems",
    imageSrc:
      "https://static.wixstatic.com/media/fe2f5667b4e74bd3b775ef0d41d820ed.jpg/v1/fill/w_2850,h_970,al_c,q_90,usm_0.66_1.00_0.01,enc_auto/fe2f5667b4e74bd3b775ef0d41d820ed.jpg",
    description:
      "By their very design, each human-created system has an impact—both intended and unintended—on human and planetary wellbeing. The goal of the sustainability movement is to modify systems to be as healthy as possible for people and our planet.",
    link: "https://www.youb.com/copy-of-healthy-ecosystems-to-sustain",
  },
  {
    uid: uuidv4(),
    type: "environmental",
    value: "Earth-Friendly Product Innovations",
    imageSrc:
      "https://static.wixstatic.com/media/11062b_e095eef6ba64487ea987b1dcc8420f84~mv2.jpg/v1/fill/w_2850,h_970,al_c,q_90,usm_0.66_1.00_0.01,enc_auto/11062b_e095eef6ba64487ea987b1dcc8420f84~mv2.jpg",
    description:
      "Earth-friendly product and technology innovations allow us to enjoy the comforts of modern life without the environmental, health, and social repercussions associated with more polluting technologies.",
    link: "https://www.youb.com/copy-of-healthy-ecosystems-to-sustain",
  },
  {
    uid: uuidv4(),
    type: "environmental",
    value: "Circular Economy",
    imageSrc:
      "https://static.wixstatic.com/media/11062b_967b66a3d2b446e1be40833ea51716ed~mv2.jpg/v1/fill/w_2850,h_970,al_c,q_90,usm_0.66_1.00_0.01,enc_auto/11062b_967b66a3d2b446e1be40833ea51716ed~mv2.jpg",
    description:
      "In a Circular Economy, products are designed from the beginning to be reusable, repairable, and recyclable/compostable, versus being designed to be discarded.",
    link: "https://www.youb.com/copy-of-healthy-ecosystems-to-sustain",
  },
  {
    uid: uuidv4(),
    type: "environmental",
    value: "Environmental Justice",
    imageSrc:
      "https://static.wixstatic.com/media/11062b_6b4b638ac32042f4bb92045e6685e953~mv2.jpg/v1/fill/w_2850,h_970,al_c,q_90,usm_0.66_1.00_0.01,enc_auto/11062b_6b4b638ac32042f4bb92045e6685e953~mv2.jpg",
    description:
      "Environmental Justice (EJ) ensures that everyone, regardless of race, color, or economic class, is safe from environmental harms. Pollution and environmental contamination impose a disproportionate burden on lower income developing countries and minority groups.",
    link: "https://www.youb.com/copy-of-individual-needs-for-healthy",
  },
];

//Healthy Environmental Actions: Impactful Actions for a Healthier Planet
export const HEA_OPTIONS = [
  {
    uid: uuidv4(),
    type: "environmental",
    value: "Responsible Consumption",
    imageSrc:
      "https://static.wixstatic.com/media/11062b_8d43336dab8b430881c8824d4131a76d~mv2.jpg/v1/fill/w_2850,h_970,al_c,q_90,usm_0.66_1.00_0.01,enc_auto/11062b_8d43336dab8b430881c8824d4131a76d~mv2.jpg",
    description:
      "Responsible consumption is intentionally purchasing food, goods, and services to limit environmental impact, support healthy practices, and ensure resource sustainability and biodiversity for future generations.",
    link: "https://www.youb.com/copy-of-individual-needs-for-healthy",
  },
  {
    uid: uuidv4(),
    type: "environmental",
    value: "Zero Waste",
    imageSrc:
      "https://static.wixstatic.com/media/b37cdf5335d24f5692dde6b91f7f9124.jpg/v1/fill/w_2850,h_970,al_c,q_90,usm_0.66_1.00_0.01,enc_auto/b37cdf5335d24f5692dde6b91f7f9124.jpg",
    description:
      "68% of waste ends up in landfills or open dumps. Landfills emit gases that worsen climate change and can result in asthma and other health problems, while open dumps, which are unregulated and are prone to fires and explosions, produce toxic gases and can contaminate soil, waterways, and groundwater.",
    link: "https://www.youb.com/copy-of-individual-needs-for-healthy",
  },
  {
    uid: uuidv4(),
    type: "environmental",
    value: "Ecosystem Restoration",
    imageSrc:
      "https://static.wixstatic.com/media/601a6af8c44541c0a785579bc4f1dacf.jpg/v1/fill/w_2850,h_970,al_c,q_90,usm_0.66_1.00_0.01,enc_auto/601a6af8c44541c0a785579bc4f1dacf.jpg",
    description:
      "Ecosystem restoration involves intentionally regenerating previously degraded ecosystems to reverse human impact, promoting biodiversity, and preventing further destruction. Restoration aims to return the ecosystem to its original state or as close as possible.",
    link: "https://www.youb.com/copy-of-individual-needs-for-healthy",
  },
];

//Healthy You: Individual Needs for Healthy Living
export const HY_OPTIONS = [
  {
    uid: uuidv4(),
    type: "social",
    value: "Safety and Security",
    imageSrc:
      "https://static.wixstatic.com/media/11062b_413009b9cce2435487816a84d6938ced~mv2.jpg/v1/fill/w_2850,h_970,al_c,q_90,usm_0.66_1.00_0.01,enc_auto/11062b_413009b9cce2435487816a84d6938ced~mv2.jpg",
    description:
      "We’re safe when we’re protected from physical, psychological, or material harm. Security is concerned with safeguarding us from threats, including economic, emotional, food, health, environmental, personal, community, and political threats.",
    link: "https://www.youb.com/copy-of-ecosystems-to-sustain-life",
  },
  {
    uid: uuidv4(),
    type: "social",
    value: "Healthy Body",
    imageSrc:
      "https://static.wixstatic.com/media/11062b_d124af2749a84773b7fdc7d9f5a0933c~mv2.jpg/v1/fill/w_2850,h_970,al_c,q_90,usm_0.66_1.00_0.01,enc_auto/11062b_d124af2749a84773b7fdc7d9f5a0933c~mv2.jpg",
    description:
      "Our bodies are our homes; we need healthy bodies in order to feel safe, secure, and to enjoy our freedom to do what we want in life.",
    link: "https://www.youb.com/copy-of-ecosystems-to-sustain-life",
  },
  {
    uid: uuidv4(),
    type: "social",
    value: "Healthy Mind",
    imageSrc:
      "https://static.wixstatic.com/media/11062b_567f7198d40441549e79da9748bf17ac~mv2.jpg/v1/fill/w_2850,h_970,al_t,q_90,usm_0.66_1.00_0.01,enc_auto/11062b_567f7198d40441549e79da9748bf17ac~mv2.jpg",
    description:
      "Our minds shape what we do, think, and feel. It allows us to come closer to reaching our goals and full potential in life.",
    link: "https://www.youb.com/copy-of-ecosystems-to-sustain-life",
  },
  {
    uid: uuidv4(),
    type: "social",
    value: "Healthy Spirit",
    imageSrc:
      "https://static.wixstatic.com/media/11062b_f38c3f3038144a64974a323a253a8e97~mv2_d_2000_1334_s_2.jpg/v1/fill/w_2000,h_681,al_c,q_85,enc_auto/11062b_f38c3f3038144a64974a323a253a8e97~mv2_d_2000_1334_s_2.jpg",
    description:
      "Spiritual health often involves a healthy lifestyle, connection with others, a sense of meaning/purpose in life, and resilience in the face of challenges.",
    link: "https://www.youb.com/copy-of-ecosystems-to-sustain-life",
  },
  {
    uid: uuidv4(),
    type: "social",
    value: "Self-Determination",
    imageSrc:
      "https://static.wixstatic.com/media/11062b_3f687cfeb2034dbfb38f37c08df07c80~mv2.jpg/v1/fill/w_2850,h_970,al_c,q_90,usm_0.66_1.00_0.01,enc_auto/11062b_3f687cfeb2034dbfb38f37c08df07c80~mv2.jpg",
    description:
      "Self-determination refers to our individual ability to make choices and manage our own life. Self-determination is key to our sense of independence and well-being.",
    link: "https://www.youb.com/copy-of-ecosystems-to-sustain-life",
  },
  {
    uid: uuidv4(),
    type: "social",
    value: "Love & Belonging",
    imageSrc:
      "https://static.wixstatic.com/media/11062b_9f02e228ef1544bbb760997ea4a11b86~mv2.jpg/v1/fill/w_2850,h_970,al_c,q_90,usm_0.66_1.00_0.01,enc_auto/11062b_9f02e228ef1544bbb760997ea4a11b86~mv2.jpg",
    description:
      "A sense of community brings our lives joy, purpose, security, and empowerment. We all need and deserve to feel love and belonging.",
    link: "https://www.youb.com/copy-of-ecosystems-to-sustain-life",
  },
];

//Healthy Us: Values for Equity and Equality
export const HU_EE_OPTIONS = [
  {
    uid: uuidv4(),
    type: "social",
    value: "Diversity - Equity - Inclusion",
    imageSrc:
      "https://static.wixstatic.com/media/11062b_e825515c93d94aa1af5b8bdd492155f9~mv2.jpeg/v1/fill/w_2850,h_970,al_c,q_90,usm_0.66_1.00_0.01,enc_auto/11062b_e825515c93d94aa1af5b8bdd492155f9~mv2.jpeg",
    description:
      "Diversity, equity and inclusion ensures fair treatment and opportunity for all. Celebrating our diversity brings us a range of mindsets and ideas that help foster creativity and innovation.",
    link: "https://www.youb.com/copy-of-individual-needs-for-healthy-1",
  },
  {
    uid: uuidv4(),
    type: "social",
    value: "Allyship & Advocacy",
    imageSrc:
      "https://static.wixstatic.com/media/11062b_2bdc3812ee0e40cdb9f782330e05e724~mv2.jpeg/v1/fill/w_2850,h_970,al_c,q_90,usm_0.66_1.00_0.01,enc_auto/11062b_2bdc3812ee0e40cdb9f782330e05e724~mv2.jpeg",
    description:
      "An ally is any person who supports, empowers, or stands up for another person or a group of people. We need to learn how to act on each other's behalf.",
    link: "https://www.youb.com/copy-of-individual-needs-for-healthy-1",
  },
  {
    uid: uuidv4(),
    type: "social",
    value: "Active Anti-Discrimination",
    imageSrc:
      "https://static.wixstatic.com/media/11062b_075c15a73bf94f26acb6366950f2ae36~mv2.jpg/v1/fill/w_2850,h_970,al_c,q_90,usm_0.66_1.00_0.01,enc_auto/11062b_075c15a73bf94f26acb6366950f2ae36~mv2.jpg",
    description:
      "Active anti-discrimination comes from a conscious decision to make frequent, consistent choices that support equity and inclusion. This requires self-awareness and reflection on our own privileges and thought patterns as we strive to overcome our (un)conscious biases.",
    link: "https://www.youb.com/copy-of-individual-needs-for-healthy-1",
  },
  {
    uid: uuidv4(),
    type: "social",
    value: "Economic Rights",
    imageSrc:
      "https://static.wixstatic.com/media/11062b_d3759c32f04a4a2da6f64d9f13ee062a~mv2.jpg/v1/fill/w_2850,h_970,al_c,q_90,usm_0.66_1.00_0.01,enc_auto/11062b_d3759c32f04a4a2da6f64d9f13ee062a~mv2.jpg",
    description:
      "All of us also have the right to a safe and healthy environment, the right to opportunities for personal development, the right to physical and mental health, and the right to social security.",
    link: "https://www.youb.com/copy-of-individual-needs-for-healthy-1",
  },
  {
    uid: uuidv4(),
    type: "social",
    value: "Equal Access to Education & Learning Opportunities",
    imageSrc:
      "https://static.wixstatic.com/media/96cdf03aca694c098847b2a3effed31d.jpg/v1/fill/w_2850,h_970,al_c,q_90,usm_0.66_1.00_0.01,enc_auto/96cdf03aca694c098847b2a3effed31d.jpg",
    description:
      "Active anti-discrimination results from a conscious decision to make frequent, consistent choices that support equity and inclusion. This requires self-awareness and reflection on our own privileges and thought patterns as we strive to overcome our (un)conscious biases.",
    link: "https://www.youb.com/copy-of-individual-needs-for-healthy-1",
  },
];

//Healthy Us: Values for Healthy Relationships
export const HU_HR_OPTIONS = [
  {
    uid: uuidv4(),
    type: "social",
    value: "Open-Mindedness & Empathy",
    imageSrc:
      "https://static.wixstatic.com/media/11062b_544404cd9da74cf08f1dc058ce7884c5~mv2.jpeg/v1/fill/w_2850,h_970,al_c,q_90,usm_0.66_1.00_0.01,enc_auto/11062b_544404cd9da74cf08f1dc058ce7884c5~mv2.jpeg",
    description:
      "Empathy helps us to understand or imagine why someone feels a certain way, and to care for their well-being. Open-mindedness is rooted in our sense of curiosity, requiring us to carefully consider new information, even if it contradicts our own ideas, biases, and beliefs.",
    link: "https://www.youb.com/copy-of-values-for-equity-equality",
  },
  {
    uid: uuidv4(),
    type: "social",
    value: "Effective Listening & Communication",
    imageSrc:
      "https://static.wixstatic.com/media/11062b_ce4205bf63bd44ab8a78054658de2b05~mv2.jpeg/v1/fill/w_2850,h_970,al_c,q_90,usm_0.66_1.00_0.01,enc_auto/11062b_ce4205bf63bd44ab8a78054658de2b05~mv2.jpeg",
    description:
      "By making a conscious effort to understand what others are saying first, we can enjoy more effective communication instead of speaking past or over one another.",
    link: "https://www.youb.com/copy-of-values-for-equity-equality",
  },
  {
    uid: uuidv4(),
    type: "social",
    value: "Respect & Trust",
    imageSrc:
      "https://static.wixstatic.com/media/11062b_3c1438751f114dd39194e7e59218cfff~mv2.jpg/v1/fill/w_2850,h_970,al_c,q_90,usm_0.66_1.00_0.01,enc_auto/11062b_3c1438751f114dd39194e7e59218cfff~mv2.jpg",
    description:
      "Two of the most important ingredients in any relationship are trust and respect. Trust can be earned after there is already some level of respect.",
    link: "https://www.youb.com/copy-of-values-for-equity-equality",
  },
  {
    uid: uuidv4(),
    type: "social",
    value: "Fairness, Truthfulness, & Transparency",
    imageSrc:
      "https://static.wixstatic.com/media/e4f1529e561049579a71251683578f2f.jpg/v1/fill/w_1800,h_613,al_c,q_85,enc_auto/e4f1529e561049579a71251683578f2f.jpg",
    description:
      "Fairness involves our ability to judge without discrimination or conflicts of interest. We are truthful when we tell facts or make statements that are true—not our opinion, beliefs, or rumors. Transparency means not hiding anything; conveying information as you know it.",
    link: "https://www.youb.com/copy-of-values-for-equity-equality",
  },
  {
    uid: uuidv4(),
    type: "social",
    value: "Forgiveness",
    imageSrc:
      "https://static.wixstatic.com/media/nsplsh_42437966705a4533615645~mv2_d_7952_5304_s_4_2.jpg/v1/fill/w_2850,h_970,al_c,q_90,usm_0.66_1.00_0.01,enc_auto/nsplsh_42437966705a4533615645~mv2_d_7952_5304_s_4_2.jpg",
    description:
      "Forgiveness can be directed towards ourselves or others and is an important process to realize peace. We must make a conscious decision to let go of feelings such as anger, resentment, regret and hostility",
    link: "https://www.youb.com/copy-of-values-for-equity-equality",
  },
];

//Healthy Us: Values for Healthy Collaboration
export const HU_HC_OPTIONS = [
  {
    uid: uuidv4(),
    type: "social",
    value: "Establishing Shared Values & Objectives",
    imageSrc:
      "https://static.wixstatic.com/media/11062b_0eea893df7ad46e0a94e584ab3eab003~mv2.jpg/v1/fill/w_1800,h_613,al_c,q_85,enc_auto/11062b_0eea893df7ad46e0a94e584ab3eab003~mv2.jpg",
    description:
      "Shared values and objectives are core components of harmonious collaboration and unity. They need to be communicated clearly for a movement or project to succeed.",
    link: "https://www.youb.com/copy-of-individual-needs-for-healthy-2",
  },
  {
    uid: uuidv4(),
    type: "social",
    value: "Dependability",
    imageSrc:
      "https://static.wixstatic.com/media/11062b_4aa46b6be77246a689a4ee9d00a88285~mv2.jpg/v1/fill/w_2850,h_970,al_c,q_90,usm_0.66_1.00_0.01,enc_auto/11062b_4aa46b6be77246a689a4ee9d00a88285~mv2.jpg",
    description:
      "The qualities of being reliable, trustworthy, and responsible are essential for a collaboration to be successful and to accomplish its goals.",
    link: "https://www.youb.com/copy-of-individual-needs-for-healthy-2",
  },
  {
    uid: uuidv4(),
    type: "social",
    value: "Effective Decision-Making",
    imageSrc:
      "https://static.wixstatic.com/media/11062b_ed558759eb1447b28d067c5e1f94e22c~mv2.jpg/v1/fill/w_2850,h_970,al_c,q_90,usm_0.66_1.00_0.01,enc_auto/11062b_ed558759eb1447b28d067c5e1f94e22c~mv2.jpg",
    description:
      "A process of gathering information and looking at the decision from a variety of perspectives. Effective Decision making can lead to a ripple effect of positivity and group confidence.",
    link: "https://www.youb.com/copy-of-individual-needs-for-healthy-2",
  },
  {
    uid: uuidv4(),
    type: "social",
    value: "Ethical Practices",
    imageSrc:
      "https://static.wixstatic.com/media/5229b1bab37f4162a34029310a20efbc.jpg/v1/fill/w_2850,h_970,al_c,q_90,usm_0.66_1.00_0.01,enc_auto/5229b1bab37f4162a34029310a20efbc.jpg",
    description:
      "Ethics are culturally and socially bound and can help strengthen our sense of self and provide meaningful interactions with others. To live ethically and reflectively can be sown into our everyday actions and how we treat others.",
    link: "https://www.youb.com/copy-of-individual-needs-for-healthy-2",
  },
  {
    uid: uuidv4(),
    type: "social",
    value: "Creativity & Freedom to Fail",
    imageSrc:
      "https://static.wixstatic.com/media/11062b_e31876cfa1fa404486c7f34cb73cb8d2~mv2.jpg/v1/fill/w_2850,h_970,al_c,q_90,usm_0.66_1.00_0.01,enc_auto/11062b_e31876cfa1fa404486c7f34cb73cb8d2~mv2.jpg",
    description:
      "Creativity and Freedom to Fail are the experiences of being open to the world and willing to experiment. This openness and sense of imagination can lead to inventions, innovation, and cutting-edge design. Part of the creative process is the ability to fail and the willingness to start.",
    link: "https://www.youb.com/copy-of-individual-needs-for-healthy-2",
  },
];

/* {
    value: "",
    imageSrc: "https://source.unsplash.com/random/325x200?cdgdsfsdfdsf",
    description: "",
  }, */
